import { useEffect, useRef } from "react";

/**
 * Fixed, full-viewport space / starfield backdrop.
 * Three tiling star layers move at different speeds on scroll to create a
 * parallax "flying through space" effect. Pure CSS gradients (no canvas) so
 * it stays smooth and cheap.
 */
const SpaceBackground = ({ contained = false }) => {
  const farRef = useRef(null);
  const midRef = useRef(null);
  const nearRef = useRef(null);

  useEffect(() => {
    let raf = null;
    const update = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      if (farRef.current) farRef.current.style.transform = `translate3d(0, ${-y * 0.12}px, 0)`;
      if (midRef.current) midRef.current.style.transform = `translate3d(0, ${-y * 0.28}px, 0)`;
      if (nearRef.current) nearRef.current.style.transform = `translate3d(0, ${-y * 0.55}px, 0)`;
      raf = null;
    };
    const onScroll = () => {
      if (raf == null) raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className={contained ? "space-bg space-bg--contained" : "space-bg"} aria-hidden="true" data-testid="space-background">
      {/* nebula glow */}
      <div className="space-nebula" />
      <div className="space-dust" />
      {/* star layers (each is 200% tall so parallax translate never reveals an edge) */}
      <div ref={farRef} className="space-stars space-stars--far" />
      <div ref={midRef} className="space-stars space-stars--mid" />
      <div ref={nearRef} className="space-stars space-stars--near" />
      {/* fade content area into deep space for readability */}
      <div className="space-vignette" />
    </div>
  );
};

export default SpaceBackground;
